export enum ProxyDestination {
    General = 0,
    Parser = 1,
    BotsOnly = 2,
    InventorySync = 3,
    ExternalMarket = 4
}

export interface Proxy {
    id: number,
    proxyHost: string,
    proxyPort: number,
    proxyLogin: string,
    proxyPassword: string,
    destination: ProxyDestination,
    connectionFailures: number,
    failedAt?: Date,
    failureReason?: string,
    resetFailureAt?: Date,
    linkedBotId?: number,
    linkedBotName?: string,
    updated?: Date | string,
    externalId?: string
}

export const ProxyDestinationDescription = {
    0: 'Общего типа',
    1: 'Для парсера',
    2: 'Для ботов',
    3: 'Синхронизация инвентарей',
    4: 'Поставщики'
}

/** Прокси ещё не привязан к слоту вендора — автосмена IP не работает. */
export function isProxyUnmapped(proxy: Pick<Proxy, 'id' | 'externalId'>): boolean {
    return proxy.id > 0 && !proxy.externalId?.trim();
}